import React from "react";
import { useState } from "react";
import styles from "./textare_input.module.css";

export const TextAreaInput = (props: any) => {
  const { value, className, onChange } = props;

  const [inputValue, setInputValue] = useState(value);

  return (
    <textarea
      className={styles.input_text_area + (className ? ` ${className}` : '')}
      onChange={(e) => {
        setInputValue(e.target.value);
        if (onChange) {
          onChange(e.target.value);
        }
      }}
      value={inputValue}
    />
  );
};
